<script>
import {onMounted, ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import LoadingPic from "@/components/assetComponents/LoadingPic.vue";
import Swals from "@/assets/js/Swals";
import L from "leaflet";
import {Device} from "@capacitor/device";
import {Geolocation} from "@capacitor/geolocation";
import swal from "sweetalert2";
import {AndroidSettings, NativeSettings} from "capacitor-native-settings";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
// import router from "@/router";

export default {
  name: "AddAdvertising",
  components: {LoadingPic, LoadingPage},
  setup() {

    let store = useStore()

    let action = useRoute().params.action

    let years = ref([])
    let today = new Date().toLocaleDateString('fa-IR-u-nu-latn');
    let parsedDate = new Date(today);
    let year = parsedDate.getFullYear();

    for (year; year >= 1340; year--) {
      years.value.push(year)
    }

    let loading = ref({
      page: false,
      pic1: false,
      pic2: false,
      pic3: false,
      pic4: false,
    })

    let data = ref({
      title: '',
      pic1: null,
      pic2: null,
      pic3: null,
      pic4: null,
      caption: '',
      phone: '',
      lat: null,
      lang: null,
      year: null,
      price: '',
      km: '',
      device: null,
    })

    let show_pic = ref({
      pic1: null,
      pic2: null,
      pic3: null,
      pic4: null,
    })

    function ads_edit() {
      let ads = FreeWorld.PinkMan(store.state.advertising , 'de')
      data.value.title = ads.title
      data.value.pic1 = ads.pic1
      data.value.pic2 = ads.pic2
      data.value.pic3 = ads.pic3
      data.value.pic4 = ads.pic4
      data.value.caption = ads.caption
      data.value.phone = ads.phone
      data.value.lat = ads.lat
      data.value.lang = ads.lang
      data.value.year = ads.year
      data.value.price = ads.price
      data.value.km = ads.km
      data.value.adver_id = ads.id

      show_pic.value = {
        pic1: ads.pic1,
        pic2: ads.pic2,
        pic3: ads.pic3,
        pic4: ads.pic4,
      }
    }
    if (action === 'edit') ads_edit()

    function upload_pic(e) {
      let id = e.target.id
      const file = e.target.files[0];

      if (file !== undefined) {
        loading.value[id] = true
        FreeWorld.Goodman(file).then((res) => {
          loading.value[id] = false
          if (res.data.status === 'ok') {
            show_pic.value[id] = URL.createObjectURL(file);
            data.value[id] = res.data.url
          } else if (res.data.message === 'Format or size not valid') {
            Swals.Fault('لطفا از فرمت عکس خود اطمینان حاصل کنید و عکس های کمتر از 2 مگابایت را آپلود کنید!')
          } else {
            Swals.Fault('متاسفانه عکس موردنظر شما آپلود نشد!')
          }
        }).catch((res) => {
          loading.value[id] = false
          Swals.Catch(res, () => {
            upload_pic(e)
          })
        })
      }
    }

    function delete_pic(id) {
      data.value[id] = null
      show_pic.value[id] = null
    }

    function add_advertising() {
      if (data.value.title.trim().length === 0) {Swals.Warning('لطفا عنوان آگهی خود را وارد کنید!');return false}
      if (!data.value.pic1) {Swals.Warning('لطفا حداقل یک عکس از آگهی خود را وارد کنید!');return false}
      if (data.value.caption.trim().length === 0) {Swals.Warning('لطفا توضیحات آگهی خود را وارد کنید!');return false}
      if (data.value.phone.length === 0) {Swals.Warning('لطفا شماره همراه خود را وارد کنید!');return false}
      if (data.value.phone.length !== 11) {Swals.Warning('لطفا شماره همراه خود را به صورت صحیح وارد کنید!');return false}
      // if (data.value.year === null) {Swals.Warning('لطفا سال ساخت را انتخاب کنید!');return false}
      // if (data.value.price.toString().length === 0) {Swals.Warning('لطفا قیمت را وارد کنید!');return false}
      // if (data.value.km.length === 0) {Swals.Warning('لطفا کارکرد خودرو را وارد کنید!');return false}

      let x = Object.assign({} , data.value , FreeWorld.PinkMan(store.state.add_advertising , 'de'))

      action === 'new' ? x.action = 'add' : x.action = 'edit'

      loading.value.page = true
      FreeWorld.Heisenberg(x , 'manage_adver' , true).then((res)=>{
        loading.value.page = false
        if (res.data.status === 'ok'){
          Swals.Done('آگهی شما با موفقیت ثبت شد' , 'HomePage')
          // window.location.href = res.data.event
        }else{
          Swals.Fault('متاسفانه آگهی شما ثبت نشد!')
        }
      }).catch((res)=>{
        loading.value.page = false
        Swals.Catch(res , add_advertising)
      })
    }

    // ****** map ******

    let map
    let my_marker = L.ExtraMarkers.icon({
      shape: 'circle',
      markerColor: 'cyan'
    })

    let center_map

    async function load_map() {

      try {
        await get_location().then(() => {
          center_map = [data.value.lat , data.value.lang]
        }).catch((e) => {
          Swals.Warning(e)
          center_map = [35.699736801550074, 51.33777700121453]
        })
      } catch (e) {
        center_map = [35.699736801550074, 51.33777700121453]
      }

      map = L.map('map').setView(center_map, 13)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map)

      map.setView(center_map, 13)
      let marker = L.marker(center_map, {icon: my_marker, draggable: false}).addTo(map);


      function keepCenterMarkerInCenter() {
        let center = map.getCenter();
        marker.setLatLng(center);
        center_map = [center.lat , center.lng]
        data.value.lat = center.lat
        data.value.lang = center.lng
      }


      map.on("drag", keepCenterMarkerInCenter);
      map.on("zoom", keepCenterMarkerInCenter);
      map.on("move", keepCenterMarkerInCenter);
    }

    function FlyTo(select_lat, select_long) {
      map.flyTo([select_lat, select_long], 13)
      document.body.style.pointerEvents = 'none'

      map.once("zoomend", () => {
        document.body.style.pointerEvents = 'auto'
      });
    }

    async function get_location(fly) {
      let deviceInfo = await Device.getInfo()
      data.value.device = deviceInfo.platform

      try {
        return new Promise((resolve, reject) => {
          if (deviceInfo.platform === 'android') {
            Geolocation.checkPermissions().then((res) => {

              if (res.location === 'granted') {
                Geolocation.getCurrentPosition().then((pos) => {
                  center_map = [pos.coords.latitude, pos.coords.longitude]
                  data.value.lat = pos.coords.latitude
                  data.value.lang = pos.coords.longitude
                  if (fly) FlyTo(pos.coords.latitude, pos.coords.longitude)
                  resolve('ok');
                }).catch(() => {
                  if (fly) Swals.Warning('متاسفانه نتوانستیم موقعیت شما را دریافت کنیم!')
                  reject('متاسفانه نتوانستیم موقعیت شما را دریافت کنیم!')
                })

              } else {
                Geolocation.requestPermissions();
                reject('ابتدا دسترسی به موقعیت مکانی را فعال کنید!')
                if (fly) Swals.Warning('ابتدا دسترسی به موقعیت مکانی را فعال کنید!')
              }

            }).catch(() => {
              swal.fire({
                icon: 'question',
                iconColor: '#FE4040',
                text: 'موقعیت یاب دستگاه روشن شود؟',
                width: 250,
                color: 'var(--font)',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'بله',
                cancelButtonText: 'خیر',
                confirmButtonColor: '#1ccf98',
                cancelButtonColor: '#ff5b5b',
                background: 'white',
              }).then(async (result) => {
                if (result.isConfirmed) {
                  await NativeSettings.openAndroid({
                    option: AndroidSettings.Location,
                  });
                  resolve('ok')
                } else {
                  if (fly) Swals.Warning('ابتدا موقعیت مکانی دستگاه را روشن کنید!')
                  reject('ابتدا موقعیت مکانی دستگاه را روشن کنید!')
                }
              })
            })

          } else {
            navigator.geolocation.getCurrentPosition((pos) => {
              center_map = [pos.coords.latitude, pos.coords.longitude]
              data.value.lat = pos.coords.latitude
              data.value.lang = pos.coords.longitude
              if (fly) FlyTo(pos.coords.latitude, pos.coords.longitude)
              resolve('ok');
            }, () => {
              if (fly) Swals.Warning('ابتدا دسترسی به موقعیت مکانی را فعال کنید!')
              reject('ابتدا دسترسی به موقعیت مکانی را فعال کنید!')
            });
          }
        })
      } catch (e) {
        Swals.Fault('متاسفانه نتوانستیم موقعیت شما را دریافت کنیم!')
      }
    }

    onMounted(() => {
      load_map()
    })

    return {
      years,
      data,
      upload_pic,
      show_pic,
      loading,
      delete_pic,
      get_location,
      add_advertising,
    }
  }
}
</script>

<template>
  <LoadingPage v-if="loading.page"></LoadingPage>

  <div id="main" :class="loading.page ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center justify-content-between p-4">
      <div class="d-flex">
        <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
        <p class="text-white font-bold font-4">ثبت آگهی</p>
      </div>

      <p onclick="window.history.back()" class="text-white font-bold font-4">انصراف</p>
    </div>

    <div style="" id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div class="">
        <p class="font-4 font-bold text-color mb-2">عنوان آگهی</p>
        <input v-model="data.title" class="bg-custom shadow-custom rounded-4 w-100 p-3" type="text">
      </div>

      <hr>

      <div class="">
        <p class="font-4 font-bold text-color mb-1">عکس آگهی</p>
        <p class="font-5 text-color mb-2">افزودن عکس بازدید اگهی شما را افزایش می دهد</p>

        <div class="d-flex justify-content-between">
          <div class="photo position-relative ">
            <LoadingPic v-if="loading.pic1"></LoadingPic>

            <img v-if="show_pic.pic1 !== null" style="top: -.2rem;right: -.2rem" class="icon-size-2 position-absolute"
                 src="../assets/img/icon-closeBgColor.svg" alt="" @click="delete_pic('pic1')">
            <input @change="upload_pic" style="display: none" id="pic1" type="file">
            <label class="h-100 w-100 rounded-4" for="pic1">
              <img v-if="show_pic.pic1 !== null" class="w-100 h-100 rounded-4" :src="show_pic.pic1" alt="">
              <img v-else class="w-100 h-100" src="../assets/img/add-photo.svg" alt="">
            </label>
          </div>

          <div :class="!show_pic.pic1 ? 'pe-none' : ''" class="photo position-relative">
            <LoadingPic v-if="loading.pic2"></LoadingPic>

            <img v-if="show_pic.pic2 !== null" style="top: -.2rem;right: -.2rem" class="icon-size-2 position-absolute"
                 src="../assets/img/icon-closeBgColor.svg" alt="" @click="delete_pic('pic2')">
            <input @change="upload_pic" style="display: none" id="pic2" type="file">
            <label class="h-100 w-100 rounded-4" for="pic2">
              <img v-if="show_pic.pic2 !== null" class="w-100 h-100 rounded-4" :src="show_pic.pic2" alt="">
              <img v-else class="w-100 h-100" src="../assets/img/add-photo.svg" alt="">
            </label>
          </div>
          <div :class="!show_pic.pic1 ? 'pe-none' : ''" class="photo position-relative">
            <LoadingPic v-if="loading.pic3"></LoadingPic>

            <img v-if="show_pic.pic3 !== null" style="top: -.2rem;right: -.2rem" class="icon-size-2 position-absolute"
                 src="../assets/img/icon-closeBgColor.svg" alt="" @click="delete_pic('pic3')">
            <input @change="upload_pic" style="display: none" id="pic3" type="file">
            <label class="h-100 w-100 rounded-4" for="pic3">
              <img v-if="show_pic.pic3 !== null" class="w-100 h-100 rounded-4" :src="show_pic.pic3" alt="">
              <img v-else class="w-100 h-100" src="../assets/img/add-photo.svg" alt="">
            </label>
          </div>
          <div :class="!show_pic.pic1 ? 'pe-none' : ''" class="photo position-relative">
            <LoadingPic v-if="loading.pic4"></LoadingPic>

            <img v-if="show_pic.pic4 !== null" style="top: -.2rem;right: -.2rem" class="icon-size-2 position-absolute"
                 src="../assets/img/icon-closeBgColor.svg" alt="" @click="delete_pic('pic4')">
            <input @change="upload_pic" style="display: none" id="pic4" type="file">
            <label class="h-100 w-100 rounded-4" for="pic4">
              <img v-if="show_pic.pic4 !== null" class="w-100 h-100 rounded-4" :src="show_pic.pic4" alt="">
              <img v-else class="w-100 h-100" src="../assets/img/add-photo.svg" alt="">
            </label>
          </div>
        </div>
      </div>

      <hr>

      <div class="">
        <p class="font-4 font-bold text-color mb-2">توضیحات آگهی</p>
        <textarea v-model="data.caption" class="bg-custom shadow-custom rounded-4 w-100 p-3" rows="6"></textarea>
      </div>

      <hr>

      <div class="">
        <p class="font-4 font-bold text-color mb-2">شماره تلفن همراه</p>
        <input v-model="data.phone" class="bg-custom shadow-custom rounded-4 w-100 p-3" type="tel" maxlength="11" onkeydown="event.key !== ' '">
      </div>

      <hr>

      <div class="">
        <p class="font-4 font-bold text-color mb-2">آدرس</p>
        <div id="map" class="map rounded-4 position-relative">
          <div style="z-index: 500;" class="max_width position-absolute bottom-5">
            <img @click="get_location(true)" class="icon-size-5 me-3" src="../assets/img/icon-my-location.png" alt="">
          </div>
        </div>
      </div>

      <hr>

      <div class="">
        <p class="font-4 font-bold text-color mb-2">سال ساخت</p>

        <select v-model="data.year" class="p-3 font-5 shadow-custom rounded-4 w-100 bg-custom text-center">
          <option :value="null">انتخاب</option>
          <option v-for="item in years" :key="item.index" :value="item">{{ item }}</option>
        </select>
      </div>

      <hr>

      <div class="">
        <div class="d-flex align-items-center justify-content-between">
        <p class="font-4 font-bold text-color mb-2">قیمت</p>
          <p v-if="data.price !== null && /^[0-9]+$/.test(data.price)" class="text-color-green font-5 font-bold">{{ Number(data.price).toLocaleString() }}</p>
        </div>

        <input v-model="data.price" class="p-3 bg-custom shadow-custom w-100 rounded-4" type="text">
      </div>

      <hr>

      <div class="">
        <p class="font-4 font-bold text-color mb-2">کارکرد</p>

        <input v-model="data.km" class="p-3 bg-custom shadow-custom w-100 rounded-4" type="text">
      </div>

      <div class="d-flex justify-content-center mt-5">
        <p @click="add_advertising" class="bg-color text-white font-bold w-35 rounded-pill p-3 text-center">ثبت</p>
      </div>
    </div>
  </div>

</template>

<style scoped>
.photo {
  width: 6rem;
  height: 6rem;
}

.map {
  height: 15rem;
}
</style>